<template>
  <div class="dlrLeftFloor" v-if="is4dScene && floorsIndex.length > 1 && !isSHowSmartGuide">
    <ul>
      <li
        @click="gotoFloor(item)"
        :class="{ active: currentFloorIndex === item }"
        v-for="item in floorsIndex"
        :key="item"
      >
        <span>{{ item + 1 }}层</span>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  inject: ['panoPromise'],
  data() {
    return {
      currentFloorIndex: 0,
      floorsIndex: [],
    };
  },
  isSHowSmartGuide: {
    type: Boolean,
    default: false,
  },
  computed: {
    ...mapGetters({
      baseInfo: 'baseInfo',
      phoneCallStatus: 'phoneCall/phoneCallStatus',
    }),
    is4dScene() {
      const fdRight = this.baseInfo.fdRight;
      if (fdRight.hasRights && fdRight.hasPublish && fdRight.sceneId) {
        return true;
      }
      return false;
    },
  },

  mounted() {
    this.setDefaultFloorData();
    this.onFlying();
  },
  methods: {
    panoLoaded() {
      return this.panoPromise.then((panoInstance) => {
        return panoInstance.loadedPromise.then(() => panoInstance);
      });
    },
    setDefaultFloorData() {
      this.panoLoaded().then((panoInstance) => {
        if (!this.is4dScene) {
          return;
        }
        this.currentFloorIndex = panoInstance.kankan.Scene.floorId;
        panoInstance.getFloors().then((data) => {
          console.log('楼层数据', data.floors);
          for (let i = 0; i < data.floors.length; i++) {
            this.floorsIndex.push(i);
          }
          this.floorsIndex = this.floorsIndex.reverse();
        });
      });
    },
    onFlying() {
      this.panoLoaded().then((panoInstance) => {
        if (!this.is4dScene) {
          return;
        }
        const panos = panoInstance.kankan.Scene.panos.list;
        panoInstance.kankan.Camera.on('flying.started', (pano) => {
          let item = panos.find((o) => o.id === pano.panoId);
          if (item) {
            this.currentFloorIndex = item.floorIndex;
          }
          console.log('楼层数据-漫游信息', pano);
        });
      });
    },
    gotoFloor(item) {
      if (item === this.currentFloorIndex) {
        return;
      }
      this.panoLoaded().then((panoInstance) => {
        if (!this.is4dScene) {
          return;
        }
        const panos = panoInstance.kankan.Scene.panos.list;
        let list = panos.filter((o) => o.floorIndex === item);
        if (list && list.length) {
          this.panoPromise.then(() => {
            panoInstance.fly(list[0].id, null, 0);
          });
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/modules/_leftFloor.scss';
</style>
